import { render, staticRenderFns } from "./FormularioInscrevase.vue?vue&type=template&id=4235765e&scoped=true&"
import script from "./FormularioInscrevase.vue?vue&type=script&lang=js&"
export * from "./FormularioInscrevase.vue?vue&type=script&lang=js&"
import style0 from "./FormularioInscrevase.vue?vue&type=style&index=0&id=4235765e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235765e",
  null
  
)

export default component.exports